import type { UnifiedBrandThemeResponse } from "@/features/theme/types/brandTheme.type";
import { fetcher } from "@/shared/lib/fetcher.client";

const THEME_ENDPOINT = "/theme";

export const getUnifiedTheme = async (): Promise<UnifiedBrandThemeResponse> => {
  const response = await fetcher.get<UnifiedBrandThemeResponse>(THEME_ENDPOINT);
  return response.data;
};
